require('snapsvg');
const anime = require('animejs');
const $window = $(window);
const swipers = [];
const circleR = 20;
const animeDelay = 9000;

$('.js-welcome-swiper').each(function () {
    const $self = $(this);
    let circleLength = 0;
    let currentAnimation = null;

    const swiper = new Swiper(this, {
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index, className) => {
                return `<div class="${className}"><span>${index + 1}</span></div>`;
            },
        },
        on: {
            init: () => {
                setTimeout(() => {
                    $self.find('.swiper-pagination-bullet').each(function () {
                        $(this).append(`
                            <div>
                                <svg class="circle-progress" width="40" height="40" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none">
                                        <circle class="circle-progress__axis" cx="22" cy="22" r="20" stroke="#979797"/>
                                        <circle class="circle-progress__fill" cx="22" cy="22" r="20" stroke="#FFFFFF" stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </svg>
                            </div>
                        `);
                    });

                    const $circlesFill = $self.find('.circle-progress__fill');

                    if ($circlesFill.length) {
                        $circlesFill.each(function () {
                            const $self = $(this);
                            const snap = new Snap($self[0]);

                            if (!circleLength) {
                                circleLength = 2 * Math.PI * circleR;
                            }

                            snap.attr({
                                strokeDasharray: circleLength,
                                strokeDashoffset: circleLength,
                            });
                        });

                        animateDotCircleProgress();

                        if (!$self.parents('.slick-current.slick-active').length) {
                            animePause();
                        }
                    }
                }, 100);
            },
            beforeSlideChangeStart: () => {
                $('.history .slick-list').css({minHeight: $('.slick-active').find('.swiper-slide-active').height()});
            },
            update: () => {
                if (!!swiper) {
                    if (!swiper.isBeginning) {
                        swiper.slideTo(0, 0);
                    }

                    animeRestart();

                    if (!$self.parents('.slick-current.slick-active').length) {
                        animePause();
                    }
                }
            },
            slideChange: animateDotCircleProgress,
        },
    });

    $self
        .on('mousemove', $.throttle(100, animePause))
        .on('mouseenter', animePause)
        .on('mouseleave', animePlay);

    swipers.push(swiper);

    function animePause() {
        if (currentAnimation) {
            currentAnimation.pause();
        }
    }

    function animePlay() {
        if (currentAnimation && currentAnimation.paused) {
            currentAnimation.play();
        }
    }

    function animeRestart() {
        if (currentAnimation) {
            currentAnimation.restart();
        }
    }

    function animateDotCircleProgress() {
        animePause();

        const $circleFill = $self.find('.swiper-pagination-bullet-active').find('.circle-progress__fill');
        let animation = $circleFill.data('animation');

        if (!animation) {
            animation = anime({
                targets: $circleFill.get(0),
                strokeDashoffset: [circleLength, 2],
                duration: animeDelay,
                easing: 'linear',
                loop: false,
                complete() {
                    return swiper.slideNext(0) || swiper.slideTo(0, 0);
                },
            });

            $circleFill.data({ animation });
        } else {
            animation.restart();
        }

        currentAnimation = animation;
    }
});

$window.on('slickSetPosition', (el, sliderName) => {
    if (sliderName === 'history') {
        for (let i = 0; i < swipers.length; i++) {
            swipers[i].update();
        }
    }
});

NLMK.adaptiveBackgrounds();



// WEBPACK FOOTER //
// ./js/main/module/sliders/welcome-swiper.js